/**
 * Centralised React Query keys for the challenges feature. Mirrors the
 * pattern used by `worldCupQueryKeys` so invalidation/prefetch in any caller
 * uses a single source of truth.
 */
export const challengesQueryKeys = {
  /** Arena combined list (PENDING + ACTIVE + COMPLETED) for the current user. */
  list: (userId: string | null) => ['challenges', userId] as const,
  /** Group leaderboard challenges scoped to the current user. */
  groupLeaderboard: (userId: string | null) =>
    ['challenges', 'group-leaderboard', userId] as const,
  /** All completed challenges for a given group. */
  groupCompleted: (groupId: string | null) =>
    ['groups', groupId, 'challenges'] as const,
  /** Paginated infinite query for completed group challenges. */
  groupCompletedInfinite: (groupId: string | null) =>
    ['groups', groupId, 'challenges', 'infinite'] as const,
  /** Joinable group challenges (PENDING + ACTIVE where current user is a participant). */
  groupJoinable: (groupId: string | null) =>
    ['groups', groupId, 'challenges', 'joinable'] as const,
  /** Auto-paginated PENDING + ACTIVE list for the Arena. */
  active: (userId: string | null) => ['challenges', 'active', userId] as const,
  /** Preview strip in the All tab (~5 most recent finished). */
  historyPreview: (userId: string | null) =>
    ['challenges', 'history-preview', userId] as const,
  /** Paginated infinite history (COMPLETED). */
  history: (userId: string | null) => ['challenges', 'history', userId] as const,
  /** Lightweight "does this user have ≥1 challenge (any status)" probe used to gate onboarding. */
  hasAny: (userId: string | null) => ['challenges', 'has-any', userId] as const,
} as const
